module.exports = __webpack_public_path__ + "src/img/cookies/cookies-cover-alt-2.d5799.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/cookies-cover-alt-2.jpg
// module id = 247
// module chunks = 0